import { useState, useEffect, useCallback } from 'react'
import type { ThemeMode } from '@/types'

export function useThemeToggle() {
    const [mode, setMode] = useState<ThemeMode>(() => {
        const saved = localStorage.getItem('theme')
        if (saved === 'dark' || saved === 'light') return saved
        return window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
    })

    useEffect(() => {
        const root = document.documentElement
        root.classList.toggle('dark', mode === 'dark')
        localStorage.setItem('theme', mode)
    }, [mode])

    const toggle = useCallback(() => {
        setMode((prev) => (prev === 'light' ? 'dark' : 'light'))
    }, [])

    return { mode, toggle }
}
